import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toArray'
})
export class ToArrayPipe implements PipeTransform {

  transform(value: any[], field: string): any[] {
    return value?.map(s => s[field]);
  }

}
